import React, {ReactNode} from 'react'
import {CardTitle} from '../../../genericComponents/typographie/CardTitle'
import {Description} from '../../../genericComponents/typographie/Description'
import {FormControlLabel, Radio} from '@mui/material'

export const NewItemServiceRequestChoiceCard = ({
                                                    icon,
                                                    title,
                                                    description,
                                                    id,
                                                    isActive = false,
                                                    isDisabled = false,
                                                    value,
                                                }: {
    icon?: ReactNode,
    title?: string,
    description?: ReactNode,
    id: string,
    isActive?: boolean,
    isDisabled?: boolean
    value: string
}) => {

    return (
        <FormControlLabel control={<Radio disabled={isDisabled} sx={{display: 'none'}}/>}
                          value={value}
                          label={
                              <div
                                  className={`service-request-choice-card ${isActive ? 'card-active' : ''} ${isDisabled ? 'card-disabled' : ''}`}
                                  data-testid={id}
                                  id={id}>
                                  <div className="icon-container">
                                      {icon && <div className="card-icon">{icon}</div>}
                                      {title && <CardTitle title={title}>{title}</CardTitle>}
                                  </div>
                                  {description && <Description className="card-description">{description}</Description>}
                              </div>
                          }
        />
    )
}
